import React, { useState, useEffect } from 'react'
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
  TablePagination,
  Box,
  Typography,
  Grid,
  Tooltip,
  Dialog,
  DialogTitle,
  IconButton,
  Divider,
  DialogContent,
  Chip,
  DialogActions,
  ListItem,
  List
} from '@mui/material'
import DeleteIcon from '@mui/icons-material/Delete'
import { Link, useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import { ApiDeleteBriefJson, ApiGetBriefJson, ApiGetbriefjsonInfoData } from '../../../apiService/Core/Apicall.tsx'
import CloseIcon from '@mui/icons-material/Close'
import InfoIcon from '@mui/icons-material/Info'

const BriefJson: React.FC = () => {
  const [briefs, setBriefs] = useState<any[]>([])
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(50);
  const [datalength, setdatalength] = useState<any>(null);
  const [open, setOpen] = useState(false);
  const [data, setData] = useState<any>([]);


  const navigate = useNavigate()
  const addOrUpdateBriefJson = (id?: any, brief?: any) => {
    if (id) {
      navigate(`/admin/add-or-update-briefjson/update/${id}`, {
        state: { brief }
      })
    } else {
      navigate('/admin/add-or-update-briefjson/add')
    }
  }
  const handleDeleteBrief = async (id: number) => {
    try {
      const data = `?briefJsonId=${id}`
      const res = await ApiDeleteBriefJson(data)
      toast.success(res.message);
      handleApiGetBriefJson();
    } catch (error) {
      console.error('Error deleting brief:', error)
      toast.error('Failed to delete brief')
    }
  }


  useEffect(() => {
    const fetchData = async () => {
      await handleApiGetBriefJson()
    }
    fetchData()
    return () => { }
  }, [page, rowsPerPage])

  const handleApiGetBriefJson = async () => {
    const data = `?offset=${rowsPerPage * page}&limit=${rowsPerPage}`;
    try {
      const res = await ApiGetBriefJson(data)
      setdatalength(res.totalCount)
      setBriefs(res.data)
    } catch (error) {
      console.error('Error deleting brief:', error)
    }
  }
  // ------------------------------------------- Chnage Pagination -----------------------------------------------
  const handleChangePage = (_event: unknown, newPage: number) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  const handleInfo = async (id: number) => {
    setOpen(true);
    try {
      const response = await ApiGetbriefjsonInfoData(`?briefJsonId=${id}`);
      if (response.status) {
        setData(response.data);
      }
    } catch (error) {
      toast.error('Failed to fetch brief info')
      console.error('Error fetching brief info:', error)
      setOpen(false);
    }
  };
  return (
    <div className='w-100 p-2'>
      <Box className='w-100 border-10 bg-light p-2 py-3'>
        <Grid container gap={2} className='align-items-center mb-5'>
          {/* REPORT OVERVIEW PROMPTS */}
          <Grid size={{ xs: 12, md: "grow" }}>
            <Typography className='fs-42 text-center'>Report Overview Prompts</Typography>
          </Grid>
          <Grid size={{ xs: 12, md: "auto" }}>
            <div className='d-flex justify-content-center'>
              <Link
                to={'/admin/add-or-update-briefjson/add'}
                // onClick={() => addOrUpdateBriefJson()}
                className='table-row-background link-btn'
              >
                Add Report Overview Prompts
              </Link>
            </div>{' '}
          </Grid>
        </Grid>
        <Box className='w-100' overflow={'auto'}>
          {/* <TableContainer component={Paper}> */}
          <Table>
            <TableHead>
              <TableRow className='table-row-background'>
                {['Title', "Description", 'Min Word', 'Max Word', 'Edit', 'Info', 'Delete'].map(
                  items => (
                    <TableCell className='tableCell-header'>{items}</TableCell>
                  )
                )}
              </TableRow>
            </TableHead>
            <TableBody>
              {briefs.map(brief => (
                <TableRow key={brief.briefJsonId}>
                  <TableCell>{brief.briefJsonTitle}</TableCell>
                  <TableCell>
                    <Tooltip title={brief.briefJsonDescription}>
                      <span>
                        {brief.briefJsonDescription?.split(" ").slice(0, 30).join(" ")}
                        {brief.briefJsonDescription?.split(" ").length > 20 && " ..."}
                      </span>
                    </Tooltip>
                  </TableCell>
                  <TableCell className='text-center'>{brief.minNoOfWords}</TableCell>
                  <TableCell className='text-center'>{brief.maxNoOfWords}</TableCell>
                  <TableCell>
                    <Link
                      // variant='contained'
                      to={`/admin/add-or-update-briefjson/update/${brief.briefJsonId}`}
                      // onClick={() =>
                      //   addOrUpdateBriefJson(brief.briefJsonId, brief)
                      // }
                      className='table-row-background link-btn'
                    >
                      Edit
                    </Link>
                  </TableCell>
                  <TableCell>
                    <IconButton
                      onClick={() => handleInfo(brief.briefJsonId)}
                    > <InfoIcon sx={{ color: "primary" }} />
                    </IconButton>
                  </TableCell>
                  <TableCell>
                    <Button
                      variant='contained'
                      className='delete-transparent'
                      onClick={() => handleDeleteBrief(brief.briefJsonId)}
                    >
                      <DeleteIcon className='delete-icon' />
                    </Button>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </Box>
        <TablePagination
          rowsPerPageOptions={[5, 10, 25, 50]}
          component="div"
          className='w-100'
          count={datalength}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
        {/* </TableContainer> */}
      </Box>
      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        fullWidth
        maxWidth="sm"
      >
        <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Typography variant="h6" fontWeight={600}>Brief Info</Typography>
          <IconButton onClick={() => setOpen(false)} size="small">
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <Divider />

        {/* <DialogContent>
          <Box mb={3}>
            <Box display="flex" alignItems="center" gap={1} mb={1.5}>
              <BusinessIcon color="primary" />
              <Typography variant="subtitle1" fontWeight={600}>
                Business ({data?.business?.length || 0})
              </Typography>
            </Box>
            {data?.business?.length > 0 ? (
              <Box display="flex" flexWrap="wrap" gap={1}>
                {data.business.map((item: { id: number; name: string }) => (
                  <Chip
                    key={item.id}
                    label={item.name}
                    variant="outlined"
                    color="primary"
                    size="small"
                  />
                ))}
              </Box>
            ) : (
              <Typography variant="body2" color="text.secondary">
                No business found
              </Typography>
            )}
          </Box>

          <Divider sx={{ my: 2 }} />

          <Box>
            <Box display="flex" alignItems="center" gap={1} mb={1.5}>
              <LocationOnIcon color="secondary" />
              <Typography variant="subtitle1" fontWeight={600}>
                Venues ({data?.venues?.length || 0})
              </Typography>
            </Box>
            {data?.venues?.length > 0 ? (
              <Box display="flex" flexWrap="wrap" gap={1}>
                {data.venues.map((item: { id: number; name: string }) => (
                  <Chip
                    key={item.id}
                    label={item.name}
                    variant="outlined"
                    color="secondary"
                    size="small"
                  />
                ))}
              </Box>
            ) : (
              <Typography variant="body2" color="text.secondary">
                No venues found
              </Typography>
            )}
          </Box>
        </DialogContent> */}

        <DialogContent>
          <Grid container spacing={3}>
            <Grid size={6}>
              <Typography variant='h5' fontWeight={'bold'} gutterBottom>Businesses</Typography>
              {data?.business?.length > 0 ? (
              <List sx={{display:'flex', flexWrap:'wrap'}}>
                {data.business.map((item: { id: number; name: string }) => (
                 <ListItem key={item.id}>{item.name}</ListItem>
                ))}
              </List>
            ) : (
              <Typography variant="body2" color="text.secondary">
                No business found
              </Typography>
            )}
            </Grid>
            <Grid size={6}>
              <Typography variant='h5' fontWeight={'bold'} gutterBottom>Sites</Typography>
              {data?.venues?.length > 0 ? (
              <List sx={{display:'flex', flexWrap:'wrap'}}>
                {data.venues.map((item: { id: number; name: string }) => (
                 <ListItem key={item.id}>{item.name}</ListItem>
                ))}
              </List>
            ) : (
              <Typography variant="body2" color="text.secondary">
                No sites found
              </Typography>
            )}
            </Grid>
          </Grid>
        </DialogContent>

        <Divider />

        <DialogActions sx={{ px: 3, py: 1.5 }}>
          <Button
            variant="contained"
            className="table-row-background"
            onClick={() => setOpen(false)}
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  )
}

export default BriefJson
